import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { useStyles } from './Styles'
import logo from '../../../../../images/etax-logo.png'
import eFinance from '../../../../../images/e-finance.png'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'

const PaymentReceiptPDFContent = ({ receiptDetails, userName, currentDate, locale }) => {
  const classes = useStyles()

  return (
    <div id={`pdfContent-${receiptDetails.receipt_number}`} className={classes.pdfContent}>
      <h3 align={'center'}><FormattedMessage id='PaymentReceipt.Dialog.Title'
                                             values={{ rec_num: receiptDetails.receipt_number }}/></h3>
      <div className='first-row'>
        <div className='dateWrapper'>
          <div className='itemWrapper'>
            <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.receiptNumber'/>}</h5>
            <span className='itemValue'>{receiptDetails.receipt_number}</span>
          </div>
          <div className='itemWrapper'>
            <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.requestNumber'/>}</h5>
            <span className='itemValue'>{receiptDetails.request_number}</span>
          </div>
          <div className='itemWrapper'>
            <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.createDate'/>}</h5>
            <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                                format="Do MMMM YYYY h:mm a">{receiptDetails.create_at}</Moment></span>
          </div>
          <div className='itemWrapper'>
            <h5 className='itemLabel'>{<FormattedMessage id='PaymentHeader.printDate'/>}</h5>
            <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                                format="Do MMMM YYYY h:mm a">{currentDate}</Moment></span>
          </div>
        </div>
        <img src={logo} alt='e-finance logo' width={150}/>
      </div>
      <div className='data-row'>
        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='UserMenu.userName'/></h5>
          <span className='itemValue'>{userName}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='List.Table.PayableName'/></h5>
          <span className='itemValue'>{receiptDetails.payable_name}</span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='List.Table.PayableType'/></h5>
          <span className='itemValue'><FormattedMessage id={('App\\Models\\Service' === receiptDetails.payable_type) ?
            'List.Table.PayableType.Option.Service' : 'List.Table.PayableType.Option.Plan'}/></span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='PaymentHeader.Subscription.receiptAmountPDF'/></h5>
          <span className='itemValue'><FormattedNumber value={receiptDetails.price}/></span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='List.Table.Duration'/></h5>
          <span className='itemValue'><FormattedMessage id={`List.Table.Duration.${receiptDetails.duration}`}/></span>
        </div>
        {!!receiptDetails?.start &&
        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='RequestHeader.DurationStart'/></h5>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY">{receiptDetails.start}</Moment></span>
        </div>
        }
        {!!receiptDetails?.end &&
        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='RequestHeader.DurationEnd'/></h5>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY">{receiptDetails.end}</Moment></span>
        </div>
        }

        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='PaymentHeader.requestState'/></h5>
          <span className='itemValue'>{receiptDetails.request_state}</span>
        </div>

        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='PaymentHeader.requestCreatedDate'/></h5>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY h:mm a">{receiptDetails.request_created_at}</Moment></span>
        </div>
        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='PaymentHeader.requestExpireDate'/></h5>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY h:mm a">{receiptDetails.request_expire_date}</Moment></span>
        </div>

        <div className='itemWrapper'>
          <h5 className='itemLabel'><FormattedMessage id='PaymentHeader.createDate'/></h5>
          <span className='itemValue'><Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                              format="Do MMMM YYYY h:mm a">{receiptDetails.create_at}</Moment></span>
        </div>
      </div>
      <div className='last-row'>
        <h5><FormattedMessage id='footer.copyrights.poweredBy'/></h5>
        <img src={eFinance} alt='e-finance logo' width={230}/>
      </div>
      <br/>
      <br/>
    </div>
  )
}

export default PaymentReceiptPDFContent
